module.exports = __webpack_public_path__ + "static/media/COMPLEX_EMERGENCIES.649a27d3.png";